export class InputManager {
  private keys: Map<string, boolean> = new Map();
  private mouseX: number = 0;
  private mouseY: number = 0;
  private mouseDeltaX: number = 0;
  private mouseDeltaY: number = 0;
  private canvas: HTMLCanvasElement;

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    this.setupEventListeners();
  }

  private setupEventListeners(): void {
    // 键盘事件
    window.addEventListener('keydown', (e) => {
      this.keys.set(e.key.toLowerCase(), true);
    });

    window.addEventListener('keyup', (e) => {
      this.keys.set(e.key.toLowerCase(), false);
    });

    // 鼠标移动事件
    this.canvas.addEventListener('mousemove', (e) => {
      const rect = this.canvas.getBoundingClientRect();
      const newMouseX = ((e.clientX - rect.left) / rect.width) * 2 - 1;
      const newMouseY = -((e.clientY - rect.top) / rect.height) * 2 + 1;

      this.mouseDeltaX = newMouseX - this.mouseX;
      this.mouseDeltaY = newMouseY - this.mouseY;

      this.mouseX = newMouseX;
      this.mouseY = newMouseY;
    });
  }

  isKeyPressed(key: string): boolean {
    return this.keys.get(key.toLowerCase()) || false;
  }

  getMouseDelta(): { x: number; y: number } {
    const delta = { x: this.mouseDeltaX, y: this.mouseDeltaY };
    // 重置 delta
    this.mouseDeltaX = 0;
    this.mouseDeltaY = 0;
    return delta;
  }

  getMousePosition(): { x: number; y: number } {
    return { x: this.mouseX, y: this.mouseY };
  }
}
